module.exports = __webpack_public_path__ + "img/template.2ce5a905.svg";